const Calculator = () => {
  const nutrition = {
    kidney: {
      calories: 30,
      sodium: 2000,
      carbohydrate: {
        none_hemo_dialysis: 0.1,
        kd_lowsalt: 0.1,
        hemo_dialysis: 0.137
      },
      fat: {
        hemo_dialysis: 0.03,
        kd_lowsalt: 0.055,
        none_hemo_dialysis: 0.055
      },
      protein: {
        hemo_dialysis: 1.2,
        kd_lowsalt: 1,
        none_hemo_dialysis: 0.8
      },
      phosphorus: 1000,
      potassium: 2500
    },
    kidney_trial: {
      calories: 30,
      sodium: 2000,
      carbohydrate: {
        none_hemo_dialysis: 0.1,
        kd_lowsalt: 0.1,
        hemo_dialysis: 0.137
      },
      fat: {
        hemo_dialysis: 0.03,
        kd_lowsalt: 0.055,
        none_hemo_dialysis: 0.055
      },
      protein: {
        hemo_dialysis: 1.2,
        kd_lowsalt: 1,
        none_hemo_dialysis: 0.8
      },
      phosphorus: 1000,
      potassium: 2500
    },
    lowsalt: {
      calories: 30,
      sodium: 2000,
      carbohydrate: 0.137,
      fat: 0.03,
      protein: 1.2,
      phosphorus: 1000,
      potassium: 2500
    },
    diabetes: {
      calories: {
        DIABETES_TYPE1: 30,
        DIABETES_TYPE2: 30,
        FIRST_TIMESTER: 30,
        SECOND_TIMESTER: 30,
        THIRD_TIMESTER: 30,
        LACTIFEROUS_PHASE: 30,
        ETC: 30
      },
      sodium: 2300,
      carbohydrate: {
        DIABETES_TYPE1: 0.137,
        DIABETES_TYPE2: 0.137,
        FIRST_TIMESTER: 0.125,
        SECOND_TIMESTER: 0.125,
        THIRD_TIMESTER: 0.125,
        LACTIFEROUS_PHASE: 0.125
      },
      fat: 0.033,
      protein: {
        DIABETES_TYPE1: 1.2,
        DIABETES_TYPE2: 1.2,
        FIRST_TIMESTER: 0.05,
        SECOND_TIMESTER: 0.05,
        THIRD_TIMESTER: 0.05,
        LACTIFEROUS_PHASE: 0.05
      },
      saturatedFat: 0.011,
      sugars: 0.025
    },
    cancer: {
      calories: 30,
      sodium: 2400,
      carbohydrate: 0.125,
      fat: 0.033,
      protein: 1.2,
      saturatedFat: 0.007,
      sugars: 0.025
    }
  };
  const nutritionCalculator = (disease, height, gender, kidneyDetail, diabetesDetail, pregnantDetail) => {
    const genderValue = gender === 'M' ? 22 : 21;
    const standardWeight = Math.floor((height ** 2 * genderValue) / 10000);

    // 칼로리
    let userCalories = 0;
    if (disease === 'diabetes') {
      if (diabetesDetail === 'DIABETES_TYPE1' || diabetesDetail === 'DIABETES_TYPE2' || diabetesDetail === 'ETC') {
        userCalories = Math.floor(standardWeight * nutrition[disease].calories[diabetesDetail]);
      } else if (pregnantDetail === 'FIRST_TIMESTER') {
        userCalories = Math.floor(standardWeight * nutrition[disease].calories[pregnantDetail]);
      } else if (pregnantDetail === 'SECOND_TIMESTER') {
        userCalories = Math.floor(standardWeight * nutrition[disease].calories[pregnantDetail] + 340);
      } else if (pregnantDetail === 'THIRD_TIMESTER') {
        userCalories = Math.floor(standardWeight * nutrition[disease].calories[pregnantDetail] + 450);
      } else if (pregnantDetail === 'LACTIFEROUS_PHASE') {
        userCalories = Math.floor(standardWeight * nutrition[disease].calories[pregnantDetail] + 320);
      }
    } else {
      userCalories = Math.floor(standardWeight * nutrition[disease].calories);
    }
    // 염분
    const userSodium = Math.floor(nutrition[disease].sodium);
    // 탄수화물
    let userCarbohydrate = 0;
    if (disease === 'kidney' || disease === 'kidney_trial') {
      userCarbohydrate = Math.floor(userCalories * nutrition[disease].carbohydrate[kidneyDetail]);
    } else if ((disease === 'diabetes' && diabetesDetail === 'DIABETES_TYPE1') || diabetesDetail === 'DIABETES_TYPE2') {
      userCarbohydrate = Math.floor(userCalories * nutrition[disease].carbohydrate[diabetesDetail]);
    } else if (disease === 'diabetes' && pregnantDetail !== null) {
      userCarbohydrate = Math.floor(userCalories * nutrition[disease].carbohydrate[pregnantDetail]);
    } else {
      userCarbohydrate = Math.floor(userCalories * nutrition[disease].carbohydrate);
    }
    // 지방
    const userFat = Math.floor(disease === 'kidney' || disease === 'kidney_trial' ? userCalories * nutrition[disease].fat[kidneyDetail] : userCalories * nutrition[disease].fat);
    // 단백질
    let userProtein = 0;
    if (disease === 'cancer' || diabetesDetail === 'DIABETES_TYPE1' || diabetesDetail === 'DIABETES_TYPE2' || kidneyDetail === 'lowsalt' || kidneyDetail === 'hemo_dialysis' || kidneyDetail === 'hemo_dialysis_trial') {
      userProtein = Math.floor(standardWeight * 1.2);
    } else if (kidneyDetail === 'none_hemo_dialysis' || kidneyDetail === 'none_hemo_dialysis_trial') {
      userProtein = Math.floor(standardWeight * 0.8);
    } else {
      userProtein = Math.floor(userCalories * 0.05);
    }
    // 포화지방
    const userSaturatedFat = Math.floor(disease === 'cancer' || disease === 'diabetes' ? userCalories * nutrition[disease].saturatedFat : 0);
    // 당
    const userSugars = Math.floor(disease === 'cancer' || disease === 'diabetes' ? userCalories * nutrition[disease].sugars : 0);
    // 인
    const userPhosphorus = disease === 'lowsalt' || disease === 'kidney' || disease === 'kidney_trial' ? nutrition[disease].phosphorus : 0;
    // 칼륨
    const userPotassium = disease === 'lowsalt' || disease === 'kidney' || disease === 'kidney_trial' ? nutrition[disease].potassium : 0;

    if (disease === 'kidney' || disease === 'lowsalt' || disease === 'kidney_trial') {
      return { calories: userCalories, sodium: userSodium, carbohydrate: userCarbohydrate, fat: userFat, protein: userProtein, phosphorus: userPhosphorus, potassium: userPotassium };
    }
    return { calories: userCalories, sodium: userSodium, carbohydrate: userCarbohydrate, fat: userFat, protein: userProtein, saturatedFat: userSaturatedFat, sugars: userSugars };
  };
  return { nutrition, nutritionCalculator };
};

export default Calculator;
